import { render } from "./Bobsled.vue?vue&type=template&id=7c7c4b88&scoped=true&bindings={\"images\":\"data\"}"
import script from "./Bobsled.vue?vue&type=script&lang=js"
export * from "./Bobsled.vue?vue&type=script&lang=js"

import "./Bobsled.vue?vue&type=style&index=0&id=7c7c4b88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c7c4b88"

export default script